import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
} from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MenuData,
  MyPATDialog,
  MyPATIconButton,
  MyPATLink,
} from "../../common";

import { bindActionCreators } from "redux";
import _ from "lodash";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CreateCoursePopup from "./CreateCoursePopup/CreateCoursePopup";
import { ChevronRight } from "@material-ui/icons";
import { id } from "date-fns/locale";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import BulkImportTest from "./BulkImportTest";
import cx from "classnames";
import MapScheduledTest from "./MapScheduledTest";
import AddBulkContent from "./AddBulkContent";
import EditRemoveContent from "./EditRemoveContent";
import { withRouter } from "react-router-dom";
import { checkForCreationForRight, checkForEditRight, checkForPublishRight } from '../helpers/helpers';
import { MODULES } from '../../../constants/comman';
import { BULK_REPORT_DOWNLOAD_URL, COURSES_TAB } from '../Constants/constants';
import { getQueryParams } from '../../../utils';
import ACLService from "../../acl/services/aclService";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "inline-block",
    },
    mainIcon: {
      color: theme.palette.grey[400],
    },
    menu: {
      transform:
        "translateY(10px) scale(1, 1) translateZ(0px) translateX(-15px) !important",
      overflow: "unset",
    },
    menuArrow: {
      content: "",
      position: "absolute",
      top: "-14px",
      right: 14,
      border: "7px solid transparent",
      borderBottomColor: theme.palette.common.white,
      display: "block",
      outline: 0,
    },
    menuArrow1: {
      content: "",
      position: "absolute",
      top: "-13px",
      right: "8.25rem",
      border: "7px solid transparent",
      borderBottomColor: theme.palette.common.white,
      display: "block",
      outline: 0,
    },
    menuArrow2: {
      content: "",
      position: "absolute",
      top: "-13px",
      right: "2.32rem",
      border: "7px solid transparent",
      borderBottomColor: theme.palette.common.white,
      display: "block",
      outline: 0,
    },
    menuArrow3: {
      content: "",
      position: "absolute",
      top: "-13px",
      right: "2.93rem",
      border: "7px solid transparent",
      borderBottomColor: theme.palette.common.white,
      display: "block",
      outline: 0,
    },
    menuArrow4: {
      content: "",
      position: "absolute",
      top: "-13px",
      right: "3.18rem",
      border: "7px solid transparent",
      borderBottomColor: theme.palette.common.white,
      display: "block",
      outline: 0,
    },
    redIndicator: {
      position: "absolute",
      right: 0,
      top: -12,
      color: "rgb(242 60 60)",
      "&>svg": {
        height: 14,
        width: 14,
      },
    },
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      '&:last-of-type':{
        borderBottom: 'none',
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
        color: "#333",
        textDecoration: "none",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    menuIcon: {
      marginRight: theme.spacing.unit,
      height: 22,
      width: 20,
      color: "#1D7DEA",
      fill: "#1D7DEA",
    },
    marginLeft5: {
      marginLeft: theme.spacing.unit,
    },
    toolTipArrow: {
      marginLeft: 10,
      "&:hover:after": {
        content: '""',
        position: "absolute",
        left: "50%",
        marginLeft: -6,
        bottom: -8,
        width: 0,
        height: 0,
        borderLeft: "5px solid rgba(0, 0, 0, 0)",
        borderRight: "5px solid rgba(0, 0, 0, 0)",
        borderBottom: "8px solid rgb(0, 0, 0)",
      },
    },
    tooltipDetails: {
      position: "absolute",
      marginTop: 42,
      zIndex: 999999,
    },
    paddingLeft: {
      paddingLeft: 40,
    },

    paddingRight: {
      paddingRight: 40,
    },
    toolTipArrowButton: {
      marginLeft: 10,
    },

    cursorPointer: {
      cursor: "pointer",
    },
    link: {
      marginRight: 15,
      fontSize: "1.125rem",
      "&:hover": {
        color: "#333",
        fontWeight: 600,
      },
    },
    darkGrey: {
      color: "#999",
    },
    activeTabStyle: {
      color: "black",
      fontWeight: 600,
      display: "inline-block",
      position: "relative",
      "&::before": {
        content: "' '",
        width: "100%",
        height: 2,
        backgroundColor: "#333",
        display: "inline-block",
        position: "absolute",
        bottom: -5,
        borderRadius: 8,
      },
    },
    paddingLeft56: {
      paddingLeft: 56,
    },
    justifyEnd: {
      justifyContent: "flex-end !important",
    },
  });

interface TopNavProps extends WithStyles<typeof styles> {
  hideCreateBttn: boolean;
  classes: any;
  showIndicator: boolean;
  icon: React.ComponentType<SvgIconProps>;
  id: string;
  menuItem: MenuData[];
  clicked?: Function;
  tooltipValue: string;
  shareButtonDisabled: boolean;
  setActiveTabInParent: Function;
  bulkReport: any;
  history: any;
}

interface TopNavState {
  openRequestPop: boolean;
  anchorEl: any;
  showTooltip: boolean;
  openBulkImport: boolean;
  activeTab: string;
  openMapScheduled:boolean;
  openAddContent:boolean;
  openEditRemove: boolean;
}

class TopNav extends Component<TopNavProps, TopNavState> {
  constructor(props: TopNavProps) {
    super(props);
    this.state = {
      openRequestPop: false,
      anchorEl: null,
      showTooltip: false,
      openBulkImport: false,
      activeTab: "Courses",
      openMapScheduled:false,
      openAddContent:false,
      openEditRemove: false
    };
    this.openHandler = this.openHandler.bind(this);
    this.closeHandler = this.closeHandler.bind(this);
  }

  openHandler = (event: any) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  closeHandler = (event: any) => {
    this.setState({
      anchorEl: null,
    });
  };

  openSyllabusTests = () => {
    this.props.history.push('course-Management/addSyllabus');
  }

  redirectToReportDownlaod = () => {
    this.props.history.push(BULK_REPORT_DOWNLOAD_URL);
  }
  
  openDialog(name:string) {
    this.setState({ [name]: true } as any);
  }
  closeDialog(name:string) {
    this.setState({ [name]: false }as any);
  }

  redirectToBulkImport() {
    this.setActiveTab("Bulk Import");
  }

  componentDidMount() {
    const activeTab = getQueryParams(this.props.history.location.search, 'activeTab');
    if (activeTab === COURSES_TAB.COURSE_CHANGE_REQUEST) {
      this.props.setActiveTabInParent(activeTab);
      this.setState({ activeTab });
    }
  }

  handleCreateCourseBttn = () => {
    //add code
    this.setState({
      openRequestPop: true,
    });
  };
  handleClosePopup = () => {
    this.setState({
      openRequestPop: false,
    });
  };

  clickedOnMenuItem(e: any, item: MenuData) {
    if (item.type == "callback") {
      e.preventDefault();
    }

    if (this.props.clicked && item.type == "callback") {
      this.props.clicked(item);
      e.preventDefault();
    }
  }

  setActiveTab(tab: string) {
    if (tab !== COURSES_TAB.BULK_IMPORT) {
      this.setState({ activeTab: tab });
      this.props.setActiveTabInParent(tab);
    }
  }

  handleHover() {
    this.setState({
      showTooltip: !this.state.showTooltip,
    });
  }

  render() {
    const { openRequestPop, openBulkImport,openMapScheduled, openAddContent, openEditRemove } = this.state;
    const { hideCreateBttn } = this.props;
    const { classes, icon, id, tooltipValue, showIndicator } = this.props;
    const { anchorEl, showTooltip } = this.state;
    const Icon = icon;
    const { authenticatedUser } = ACLService.getUserDetailsFromStorage();
    let currentURL1: any = window.location.href.split("/");
    let currentURL: any = window.location.href.split("/");
    currentURL = currentURL.includes("course");
    currentURL1 = currentURL1.includes("milestoneDetail");
    const createButtonVisible = !hideCreateBttn && checkForCreationForRight(MODULES.COURSE);
    const editAndPublishRight = checkForEditRight(null, MODULES.COURSE) && checkForPublishRight(MODULES.COURSE);
    const isMasterClientIdExists = _.get(authenticatedUser, 'clientId.masterClient.id', null);
    return (
      <>
        <Grid container alignItems="center" spacing={24}>
          <Grid item xs={3}>
            <Typography variant="h4">Courses</Typography>
          </Grid>
          <Grid item xs={9}>
            <Grid
              container
              className={(this.props.bulkReport && this.props.bulkReport.length === 0) ? (!isMasterClientIdExists ? '' : classes.justifyEnd) :  ""}
              justify="space-between"
              alignItems="center"
            >
              {((this.props.bulkReport && this.props.bulkReport.length > 0) || !isMasterClientIdExists) && (
                <Grid item>
                  <Grid className={classes.paddingLeft56}>
                    {
                      <span
                        className={
                          this.state.activeTab === "Courses"
                            ? cx(
                                classes.cursorPointer,
                                classes.link,
                                classes.darkGrey,
                                classes.activeTabStyle
                              )
                            : cx(classes.link, classes.cursorPointer)
                        }
                        onClick={() => {
                          this.setActiveTab("Courses");
                        }}
                      >
                        Course Listing&nbsp;
                      </span>
                    }
                    {/* &nbsp;&nbsp;
                    {
                      <span
                        className={
                          this.state.activeTab === "Bulk Import"
                            ? cx(
                                classes.link,
                                classes.cursorPointer,
                                classes.darkGrey,
                                classes.activeTabStyle
                              )
                            : cx(classes.link, classes.cursorPointer)
                        }
                        onClick={() => {
                          this.setActiveTab("Bulk Import");
                        }}
                      >
                        Bulk Operation Report&nbsp;
                      </span>
                    } */}
                    &nbsp;&nbsp;
                    {
                      <span
                        className={
                          this.state.activeTab === "Course Change Request"
                            ? cx(
                                classes.link,
                                classes.cursorPointer,
                                classes.darkGrey,
                                classes.activeTabStyle
                              )
                            : cx(classes.link, classes.cursorPointer)
                        }
                        onClick={() => {
                          this.setActiveTab("Course Change Request");
                        }}
                      >
                        Course Plan Change Request
                      </span>
                    }
                  </Grid>
                </Grid>
              )}
              <Grid item>
                {createButtonVisible && (
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleCreateCourseBttn.bind(this)}
                    >
                      Create Course
                    </Button>

                    {openRequestPop && (
                      <CreateCoursePopup
                        open={openRequestPop}
                        onClose={this.handleClosePopup}
                      />
                    )}
                  </span>
                )}

                <MyPATIconButton
                  onClick={this.openHandler.bind(this)}
                  buttonVariant="flat"
                  // onMouseOver={this.handleHover.bind(this)}
                  // onMouseOut={this.handleHover.bind(this)}
                  className={classes.toolTipArrowButton}
                >
                  <MoreVertIcon classes={{ root: classes.mainIcon }} />
                  {showIndicator && (
                    <span className={classes.redIndicator}>
                      <FiberManualRecordIcon />
                    </span>
                  )}
                </MyPATIconButton>

                <Menu
                  id={id}
                  classes={{ paper: classes.menu }}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.closeHandler.bind(this)}
                  onMouseLeave={this.closeHandler.bind(this)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  getContentAnchorEl={null}
                  disableAutoFocusItem
                >
                  {editAndPublishRight && <MenuItem className={classes.menuItem}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.openDialog("openBulkImport");
                      }}
                    >
                      {" "}
                      Bulk Import Scheduled
                    </a>
                  </MenuItem>}
                  {editAndPublishRight && <MenuItem className={classes.menuItem}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.openDialog("openMapScheduled");
                      }}
                    >
                      {" "}
                      Map Scheduled Tests
                    </a>
                  </MenuItem>}
                  {editAndPublishRight && <MenuItem className={classes.menuItem}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.openSyllabusTests()
                      }}
                    >
                      {" "}
                      Add Syllabus For Scheduled Tests
                    </a>
                  </MenuItem>}
                  {editAndPublishRight && <MenuItem className={classes.menuItem}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.openDialog("openAddContent");
                      }}
                    >
                      {" "}
                     Bulk Add Content
                    </a>
                  </MenuItem>}
                  {editAndPublishRight && <MenuItem className={classes.menuItem}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.openDialog("openEditRemove");
                      }}
                    >
                      {" "}
                     Bulk Edit/Remove Content
                    </a>
                  </MenuItem>}
                  <MenuItem className={classes.menuItem}>
                    <a
                      onClick={this.redirectToReportDownlaod}
                    >
                      Bulk Operation Report
                    </a>
                  </MenuItem>
                  <div className={classes.menuArrow} />
                </Menu>
               
              </Grid>
            </Grid>
            <BulkImportTest
              openBulkImport={openBulkImport}
              closeBulkImport={() => this.closeDialog("openBulkImport")}
              redirectToBulkImport={() => this.redirectToBulkImport()}
            />
             {this.state.openMapScheduled && <MapScheduledTest
              openMapScheduled={openMapScheduled}
              closeBulkImport={() => this.closeDialog("openMapScheduled")}
              redirectToBulkImport={() => this.redirectToBulkImport()}
            />}
            {
              this.state.openAddContent && <AddBulkContent
              openAddContent={openAddContent}
              closeBulkImport={() => this.closeDialog("openAddContent")}
              redirectToBulkImport={() => this.redirectToBulkImport()}
              />
            }
             {
              this.state.openEditRemove && <EditRemoveContent
              openBulkImport={openEditRemove}
              closeBulkImport={() => this.closeDialog("openEditRemove")}
              redirectToBulkImport={() => this.redirectToBulkImport()}
              />
            }
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
  receivedContentRequestsData:
    state.contentRequestReducer.contentRequestReducer
      .receivedContentRequestsData,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(withStyles(styles)(TopNav)));